import { render, staticRenderFns } from "./ChildUpsertIp.vue?vue&type=template&id=8b38973a"
import script from "./ChildUpsertIp.vue?vue&type=script&lang=js"
export * from "./ChildUpsertIp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports